// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractsTableV2QueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidContractsFilter>;
  order?: Types.InputMaybe<Types.BidContractOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BidContractsTableV2Query = { __typename?: 'Query', bidContractsPage: { __typename?: 'BidContractsPage', entities: Array<{ __typename?: 'BidContract', id: string, displayName: string, isPrimary?: boolean | null | undefined, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, scopeSource?: { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource } | null | undefined, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, costCodeAwards: Array<{ __typename?: 'CostCodeAward', isPrimary: boolean, isSecondary: boolean, costCode: { __typename?: 'CostCode', id: string, number: string } }>, bidContract: { __typename?: 'BidContract', id: string, projects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }> } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type BidContractsTableV2_BidContractFragment = { __typename?: 'BidContract', id: string, displayName: string, isPrimary?: boolean | null | undefined, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, scopeSource?: { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource } | null | undefined, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, costCodeAwards: Array<{ __typename?: 'CostCodeAward', isPrimary: boolean, isSecondary: boolean, costCode: { __typename?: 'CostCode', id: string, number: string } }>, bidContract: { __typename?: 'BidContract', id: string, projects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }> } } };

export const BidContractsTableV2_BidContractFragmentDoc = gql`
    fragment BidContractsTableV2_BidContract on BidContract {
  id
  displayName
  projects {
    ...Named
  }
  developments {
    ...Named
  }
  scopeSource {
    code
  }
  latestRevision {
    id
    version
    startDate
    endDate
    status {
      code
      name
    }
    costCodes {
      id
      number
    }
    costCodeAwards {
      costCode {
        id
        number
      }
      isPrimary
      isSecondary
    }
    bidContract {
      id
      projects {
        id
      }
    }
    startDate
    endDate
  }
  isPrimary
}
    ${NamedFragmentDoc}`;
export const BidContractsTableV2Document = gql`
    query BidContractsTableV2($filter: BidContractsFilter, $order: BidContractOrder, $page: PageFilter) {
  bidContractsPage(filter: $filter, order: $order, page: $page) {
    entities {
      ...BidContractsTableV2_BidContract
    }
    pageInfo {
      totalCount
    }
  }
}
    ${BidContractsTableV2_BidContractFragmentDoc}`;

/**
 * __useBidContractsTableV2Query__
 *
 * To run a query within a React component, call `useBidContractsTableV2Query` and pass it any options that fit your needs.
 * When your component renders, `useBidContractsTableV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractsTableV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBidContractsTableV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<BidContractsTableV2Query, BidContractsTableV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractsTableV2Query, BidContractsTableV2QueryVariables>(BidContractsTableV2Document, options);
      }
export function useBidContractsTableV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractsTableV2Query, BidContractsTableV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractsTableV2Query, BidContractsTableV2QueryVariables>(BidContractsTableV2Document, options);
        }
// @ts-ignore
export function useBidContractsTableV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractsTableV2Query, BidContractsTableV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractsTableV2Query, BidContractsTableV2QueryVariables>;
export function useBidContractsTableV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractsTableV2Query, BidContractsTableV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractsTableV2Query | undefined, BidContractsTableV2QueryVariables>;
export function useBidContractsTableV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractsTableV2Query, BidContractsTableV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractsTableV2Query, BidContractsTableV2QueryVariables>(BidContractsTableV2Document, options);
        }
export type BidContractsTableV2QueryHookResult = ReturnType<typeof useBidContractsTableV2Query>;
export type BidContractsTableV2LazyQueryHookResult = ReturnType<typeof useBidContractsTableV2LazyQuery>;
export type BidContractsTableV2SuspenseQueryHookResult = ReturnType<typeof useBidContractsTableV2SuspenseQuery>;
export type BidContractsTableV2QueryResult = Apollo.QueryResult<BidContractsTableV2Query, BidContractsTableV2QueryVariables>;